import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Flex, Typography, App, Spin, Switch } from "antd";

import Breadcrumbs from "@/components/ui/Breadcrumbs";
import UnitMembersTable from "@/components/tables/UnitMembersTable";

import { useTableAutoHeight } from "@/hooks/useTableAutoHeight";

import { getItem } from "@/api/units";

import routes from "@/routes";

const { Title } = Typography;

// Участники РГ
const UnitMembers = () => {
  const { unit_uuid } = useParams();
  const { message } = App.useApp();

  // Данные
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [showDeletedMembers, setShowDeletedMembers] = useState(false);

  const tableData = useMemo(() => {
    const members = data?.members ?? [];
    const excludedMembers = data?.excludedMembers ?? [];

    if (showDeletedMembers) {
      return [
        ...members,
        ...excludedMembers.map((member) => ({
          ...member,
          removed_from_unit: true,
        })),
      ];
    }

    return members;
  }, [data, showDeletedMembers]);

  // Автоматическая высота таблицы
  const { tableContainerRef, tableHeight, headerHeight } = useTableAutoHeight([
    tableData,
  ]);

  // Запрос на сервер для получения данных
  const fetchData = async () => {
    setIsLoading(true);

    try {
      const unit = await getItem(unit_uuid);
      setData(unit);
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    } finally {
      setIsLoading(false);
    }
  };

  //  initial fetch
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [unit_uuid]);

  return (
    <>
      {isLoading ? (
        <div className="spin">
          <Spin size="large" />
        </div>
      ) : (
        data && (
          <Flex vertical gap={25} className="h-100">
            <Flex vertical gap={10}>
              <Breadcrumbs
                items={[
                  {
                    title: "Главная",
                    href: routes.dashboards,
                  },
                  {
                    title: data?.name,
                  },
                  {
                    title: "Участники",
                  },
                ]}
              />

              <Title level={2} className="no-margin">
                Участники
              </Title>
            </Flex>

            <Flex gap={10}>
              <Switch
                value={showDeletedMembers}
                onChange={setShowDeletedMembers}
              />
              Показывать исключенных
            </Flex>
            <div ref={tableContainerRef} style={{ flex: 1, minHeight: 0 }}>
              <UnitMembersTable
                data={tableData}
                loading={isLoading}
                scroll={{ x: "100%", y: tableHeight - headerHeight }}
              />
            </div>
          </Flex>
        )
      )}
    </>
  );
};

export default UnitMembers;
